// Translation file for the application

export const translations = {
  en: {
    // Student deletion messages
    'delete.student.title': 'Delete Student',
    'delete.student.confirm': 'Are you sure to delete the account of \'{name}\' ?',
    'delete.student.confirmWithReservations': '⚠️ This student has {count} upcoming reservation{plural}. All reservations will be cancelled if you proceed. Are you sure to delete \'{name}\' ?',
    'delete.student.button': 'Yes, delete',
    'delete.student.success': 'Student deleted',
    'delete.student.error': 'Error deleting student',
    
    // Common
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.error': 'Error',
    'common.success': 'Success',
  },
  ar: {
    // Student deletion messages
    'delete.student.title': 'حذف الطالب',
    'delete.student.confirm': 'هل أنت متأكد من حذف حساب \'{name}\' ؟',
    'delete.student.confirmWithReservations': '⚠️ هذا الطالب لديه {count} حجز{plural} قادم. سيتم إلغاء جميع الحجوزات عند المتابعة. هل أنت متأكد من حذف \'{name}\' ؟',
    'delete.student.button': 'نعم، احذف',
    'delete.student.success': 'تم حذف الطالب',
    'delete.student.error': 'خطأ في حذف الطالب',
    
    // Common
    'common.cancel': 'إلغاء',
    'common.confirm': 'تأكيد',
    'common.error': 'خطأ',
    'common.success': 'نجح',
  }
}

// Helper function to get translated text with variable replacement
export function translate(key, locale = 'ar', variables = {}) {
  const translation = translations[locale]?.[key] || translations.en[key] || key;
  
  // Replace variables like {name}, {count}, etc.
  return translation.replace(/\{(\w+)\}/g, (match, varName) => {
    return variables[varName] || match;
  });
}

// Helper function for pluralization
export function pluralize(count, singular, plural) {
  return count === 1 ? singular : plural;
}

